/**
 * Tells whether the fullscreen requirement is turned off by configuration.
 *
 * Meant for local testing only: set `VUE_APP_DISABLE_FULLSCREEN=true` in a
 * local env file to work on task routes without the user-attention modal.
 * Any other value, or no value, keeps fullscreen required (the default).
 *
 * The flag is ignored in staging and production builds (both run with
 * `NODE_ENV=production`), so it can never turn off attention enforcement
 * for real students.
 */
export default function isFullscreenDisabled(): boolean {
    if (process.env.NODE_ENV === 'production') return false;

    return process.env.VUE_APP_DISABLE_FULLSCREEN === 'true';
}
